/* @ngInject */
function MessageReactionsController ($rootScope, $scope) {
  const defaultEmojis = [
    { code: '👍', slug: 'thumbsup' },
    { code: '❤️', slug: 'heart' },
    { code: '😂', slug: 'laugh' },
    { code: '😮', slug: 'wow' },
    { code: '👎', slug: 'thumbsdown' },
    { code: '🙏', slug: 'pray' }
  ]
  $scope.availableReactions = defaultEmojis
  $scope.showReactionPicker = false

  $scope.toggleReactionPicker = () => {
    $scope.showReactionPicker = !$scope.showReactionPicker
  }

  $scope.addReaction = (emoji) => {
    $scope.onReact({ emoji })
    $scope.showReactionPicker = false
  }

  $scope.getReactionTooltip = (reaction) => {
    if (!reaction.users || reaction.users.length === 0) return ''
    return reaction.users.map(user => user.name).join(', ')
  }
}

export { MessageReactionsController }
